import { Text } from 'atoms/Text/Text';
import { Spacer } from 'components/Spacer/Spacer';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Styles } from './styles';

type ProductsFeatureProps = {
  productDesc: string;
  features?: string;
  companyName: string;
  website: string;
};

export const ProductsFeature: React.FC<ProductsFeatureProps> = ({
  productDesc,
  features,
  companyName,
  website,
}) => {
  return (
    <Styles.Wrapper>
      <Text.body1>Product features</Text.body1>
      <Spacer.Column numberOfSpaces={4} />
      <div className="markdown">
        <ReactMarkdown>{productDesc}</ReactMarkdown>
        <Spacer.Column numberOfSpaces={4} />
        {!!features && (
          <>
            <ReactMarkdown>{features}</ReactMarkdown>
            <Spacer.Column numberOfSpaces={4} />
          </>
        )}
      </div>
      <Styles.Link href={website} target="_blank">
        Visit {companyName}'s website for more info
      </Styles.Link>
    </Styles.Wrapper>
  );
};
